import gql from 'graphql-tag';
import { collectionViewUser } from './user';
import { FilterByComponent } from './viewTemplate';
import { WorkflowEntity, WorkflowTemplate } from './workflow';

export const RecurringEntitiesSchedule = gql`
  fragment RecurringEntitiesSchedule on RecurringEntitiesSchedule {
    id
    name
    workflowTemplateId
    rrule
    dateComponentId
    extend {
      autoExtend {
        seriesFilter {
          ...FilterByComponent
        }
        minimumInSeries
      }
    }
  }

  ${FilterByComponent}
`;

export const EntityRefs = gql`
  fragment EntityRefs on EntityRefs {
    workflowTemplateRefs {
      ...WorkflowTemplate
    }
    personRefs {
      ...CollectionViewUser
    }
    workflowEntityRefs {
      ...WorkflowEntity
    }
    recurringEntitiesScheduleRefs {
      ...RecurringEntitiesSchedule
    }
  }

  ${WorkflowEntity}
  ${WorkflowTemplate}
  ${collectionViewUser}
  ${RecurringEntitiesSchedule}
`;
